import { cn } from '@/lib/utils';

// Matches the mockup `.tog` spec exactly: 30×16 track, 12px knob, 2px inset.
// Single source of truth for on/off toggles across the app.
export function Switch({
  checked,
  onCheckedChange,
  className,
  disabled,
  'aria-label': ariaLabel,
}: {
  checked: boolean;
  onCheckedChange: () => void;
  className?: string;
  disabled?: boolean;
  'aria-label'?: string;
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={onCheckedChange}
      className={cn(
        'relative h-4 w-[30px] shrink-0 rounded-full transition-colors',
        disabled && 'opacity-50 cursor-not-allowed',
        checked ? 'bg-(--color-green)' : 'bg-(--color-border)',
        className,
      )}
    >
      <span
        className={cn(
          'absolute top-0.5 size-3 rounded-full bg-white shadow-[0_1px_3px_rgba(0,0,0,0.2)] transition-[left]',
          checked ? 'left-4' : 'left-0.5',
        )}
      />
    </button>
  );
}
